module.exports = __webpack_public_path__ + "static/media/flutter.54f67219.png";